<form-popup
    titleText="Change Password"
    [visible]="visible"
    [width]="360"
    [height]="'auto'"
    [wrapperAttr]="{ class: 'change-profile-password-popup' }"
    [isSaveDisabled]="isSaveDisabled"
    (save)="saveNewPassword()"
    (visibleChange)="changeVisible($event)"
>
    <dx-form
        #form
        labelMode="outside"
        labelLocation="top"
        [showColonAfterLabel]="true"
    >
        <dxi-item>
            <dxo-label text="New Password"></dxo-label>
            <password-text-box
                stylingMode="filled"
                [(value)]="formData['password']"
                (valueChanged)="onNewPasswordChanged()"
                [autocomplete]="false"
            ></password-text-box>
        </dxi-item>

        <dxi-item>
            <dxo-label text="Confirm New Password"></dxo-label>
            <password-text-box
                #confirmField
                stylingMode="filled"
                [(value)]="formData['confirmedPassword']"
                [validators]="confirmPasswordValidators"
                (valueChanged)="onFieldChanged()"
                [autocomplete]="false"
            >
            </password-text-box>
        </dxi-item>
    </dx-form>
</form-popup>
